import {
  FormControlLabel,
  formControlLabelClasses,
  styled
} from '@mui/material';

interface StyledFormControlLabelProps {
  checked: boolean;
}

const StyledFormControlLabel = styled(
  FormControlLabel
)<StyledFormControlLabelProps>(({ theme, checked }) => ({
  [`&.${formControlLabelClasses.root}`]: {
    color: checked ? theme.palette.info.main : theme.palette.grey[900],
    width: '100%'
  }
}));

export { StyledFormControlLabel };
